// extracted by mini-css-extract-plugin
export default {"wrapper":"rsJ0W5IT0XM7lRvSTlJl","title":"DPbPXH1fNKNhf8wuoYS6","subtitle":"nZ2YQsysKOGQUrV0HPho","noData":"TCfD0AD1T6iDvyUwBFvh"};